import { Text, VStack } from "@astryxdesign/core";
import type { Trip } from "../types/api";

const STATUS_LABELS = [
  ["pendingTasks", "pending"],
  ["inProgressTasks", "in progress"],
  ["completedTasks", "completed"],
  ["failedTasks", "failed"],
  ["cancelledTasks", "cancelled"],
] as const;

export function TripProgress({ trip }: { trip: Trip }) {
  const stops = trip.waypoints?.length;
  const total = trip.totalTasks;
  const hasProgress = STATUS_LABELS.every(
    ([key]) => typeof trip[key] === "number"
  );
  return (
    <VStack gap={1} align="start">
      <Text size="xsm" color="secondary">
        {stops === undefined
          ? "Stops unavailable"
          : `${stops} stop${stops === 1 ? "" : "s"}`}{" "}
        ·{" "}
        {total === undefined
          ? "Task total unavailable"
          : `${total} task${total === 1 ? "" : "s"}`}
      </Text>
      <Text size="xsm" color="secondary">
        {hasProgress
          ? STATUS_LABELS.map(([key, label]) => `${trip[key]} ${label}`).join(
              " · "
            )
          : "Task progress unavailable"}
      </Text>
    </VStack>
  );
}
